'use client';

import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import { useHttp } from '@/shared/api/provider';
import { classNames } from '@/shared/lib/classnames/classnames';
import { formatMoney } from '@/shared/lib/string/formatMoney';
import { Button } from '@/shared/ui/button';
import type { IPagination } from '@/entities/common/types/api';
import type { IServiceDoctor } from '@/entities/service/model/types';
interface Props {
  alias: string;
  initialServices: IServiceDoctor[];
  initialPagination: IPagination;
}
export const ServicesListClient: React.FC<Props> = ({
  alias,
  initialServices,
  initialPagination
}) => {
  const t = useTranslations();
  const repositories = useHttp();
  const [currentServices, setCurrentServices] = useState(initialServices);
  const [pagination, setPagination] = useState(initialPagination);
  const [loading, setLoading] = useState(false);
  const loadMoreServices = async () => {
    if (!pagination.hasNextPage || loading) return;
    setLoading(true);
    const nextPage = pagination.currentPage + 1;
    const {
      services: newServices,
      pagination: newPagination
    } = await repositories.doctor.getDoctorServicesByAlias(alias, nextPage);
    setCurrentServices([...currentServices, ...newServices]);
    setPagination(newPagination);
    setLoading(false);
  };
  return <>
      <div className="rounded-lg bg-bgPrimary">
        <h2 className="mb-4 text-center">{`${t('doctor.services.title')}`}</h2>
        <ul className="space-y-4">
          {currentServices.map((service, index) => <li key={index} className="flex items-center justify-between border-b py-2 last:border-b-0">
              <span className="max-w-48 hyphens-auto text-balance text-sm text-gray-700 md:max-w-max">
                {service.name}
              </span>
              {service.price ? <span className="ml-4 flex-none text-base font-bold">{formatMoney(service.price)} ₸</span> : <span className="ml-4 flex-none text-base">{t('doctor.price.no_price')}</span>}
            </li>)}
        </ul>
      </div>
      {pagination.hasNextPage && <Button variant={'secondary-main'} onClick={loadMoreServices} textWeight={'bold'} className={classNames('mt-4 w-full py-3 text-center')} loading={loading} disabled={loading}>
          {t('doctor.services.show_more')}
        </Button>}
    </>;
};